import React from 'react';

import { Icons, Tooltip } from '@components/common';

import { portalTasksStatuses } from '@constants/common';

export const getTaskStatusIconWithTooltip = (status?: string) => {
	const defaultIcon = (
		<Tooltip
			content='To Do'
			placement='top'
		>
			<div>{Icons.taskToDo()}</div>
		</Tooltip>
	);

	if (!status) {
		return defaultIcon;
	}

	if (status === portalTasksStatuses.inProgress) {
		return (
			<Tooltip
				content='In Progress'
				placement='top'
			>
				<div>{Icons.taskInProgress()}</div>
			</Tooltip>
		);
	} else if (status === portalTasksStatuses.done) {
		return (
			<Tooltip
				content='Done'
				placement='top'
			>
				<div>{Icons.taskDone()}</div>
			</Tooltip>
		);
	}

	return defaultIcon;
};
